import {
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Spin,
  message,
} from "antd";
import React, { useState, useEffect } from "react";
import { createRegistration } from "../../api-calls/RegistrationAPI";
import TextArea from "antd/es/input/TextArea";
import {
  NEW_INDIVIDUAL_REGISTRATION_API_CONSTANT,
  NEW_TEAM_REGISTRATION_API_CONSTANT,
} from "../../constants/APIConstants";

const RegistrationFormComponent = () => {
  const [loading, setLoading] = useState(false);
  const [typeOfRegistration, setTypeOfRegistration] = useState();
  const [ageGroup, setAgeGroup] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [eventType, setEventType] = useState();
  // const [eventName, setEventName] = useState();

  // console.log("Event Name", selectedEvent);
  // console.log("Age Group", ageGroup);

  useEffect(() => {
    if (selectedEvent) {
      const event =
        typeOfRegistration === "TEAM"
          ? multiplayerGames.find((e) => e.value === selectedEvent)
          : singlePlayerGames.find((e) => e.value === selectedEvent);
      setSubcategories(event ? event.groups : []);
    }
    // eslint-disable-next-line
  }, [selectedEvent]);

  const handleEventChange = (value) => {
    setSelectedEvent(value);
    // Reset ageGroup when event changes
    setAgeGroup(null);
  };

  const handleSubcategoryChange = (value) => {
    setAgeGroup(value);
  };

  const singlePlayerGames = [
    {
      name: "BADMINTON",
      value: "BADMINTON",
      groups: [
        { name: "Under -11 Boys", value: "Under -11 Boys" },
        { name: "Under -13 Boys", value: "Under -13 Boys" },
        { name: "Under-15 Boys", value: "Under-15 Boys" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "OPEN Boys", value: "OPEN Boys" },
        { name: "Under -11 Girls", value: "Under -11 Girls" },
        { name: "Under -13 Girls", value: "Under -13 Girls" },
        { name: "Under-15 Girls", value: "Under-15 Girls" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "OPEN Girls", value: "OPEN Girls" },
      ],
    },
    {
      name: "CYCLING",
      value: "CYCLING",
      groups: [
        { name: "Under- 5 Boys", value: "Under- 5 Boys" },
        { name: "Under- 5 Girls", value: "Under- 5 Girls" },
        { name: "Under- 8 Boys", value: "Under- 8 Boys" },
        { name: "Under- 8 Girls", value: "Under- 8 Girls" },
        { name: "Under- 11 Boys", value: "Under- 11 Boys" },
        { name: "Under- 11 Girls", value: "Under- 11 Girls" },
        { name: "Under- 14 Boys", value: "Under- 14 Boys" },
        { name: "Under- 14 Girls", value: "Under- 14 Girls" },
        { name: "Under- 17 Boys", value: "Under- 17 Boys" },
        { name: "Under- 17 Girls", value: "Under- 17 Girls" },
        { name: "Under- 19 Boys", value: "Under- 19 Boys" },
        { name: "Under- 19 Girls", value: "Under- 19 Girls" },
        { name: "Under- 25 Boys", value: "Under- 25 Boys" },
        { name: "Under- 25 Girls", value: "Under- 25 Girls" },
        { name: "Under- 30 Boys", value: "Under- 30 Boys" },
        { name: "Under- 30 Girls", value: "Under- 30 Girls" },
        { name: "Under- 35 Boys", value: "Under- 35 Boys" },
        { name: "Under- 35 Girls", value: "Under- 35 Girls" },
        { name: "Under- 40 Boys", value: "Under- 40 Boys" },
        { name: "Under- 40 Girls", value: "Under- 40 Girls" },
        { name: "Under- 45 Boys", value: "Under- 45 Boys" },
        { name: "Under- 45 Girls", value: "Under- 45 Girls" },
        { name: "Under- 50 Boys", value: "Under- 50 Boys" },
        { name: "Under- 50 Girls", value: "Under- 50 Girls" },
        { name: "Under- 55 Boys", value: "Under- 55 Boys" },
        { name: "Under- 55 Girls", value: "Under- 55 Girls" },
        { name: "Under- 60 Boys", value: "Under- 60 Boys" },
        { name: "Under- 60 Girls", value: "Under- 60 Girls" },
        { name: "Under- 65 Boys", value: "Under- 65 Boys" },
        { name: "Under- 65 Girls", value: "Under- 65 Girls" },
        { name: "Under-70 Boys", value: "Under-70 Boys" },
        { name: "Under- 70 Girls", value: "Under- 70 Girls" },
      ],
    },
    {
      name: "ATHLETICS",
      value: "ATHLETICS",
      groups: [
        { name: "Under-14 100 Meter Girls", value: "Under-14 100 Meter Girls" },
        { name: "Under-14 200 Meter Girls", value: "Under-14 200 Meter Girls" },
        { name: "Under-14 400 Meter Girls", value: "Under-14 400 Meter Girls" },
        { name: "Under-14 600 Meter Girls", value: "Under-14 600 Meter Girls" },
        { name: "Under-14 100 Meter Boys", value: "Under-14 100 Meter Boys" },
        { name: "Under-14 200 Meter Boys", value: "Under-14 200 Meter Boys" },
        { name: "Under-14 400 Meter Boys", value: "Under-14 400 Meter Boys" },
        { name: "Under-14 600 Meter Boys", value: "Under-14 600 Meter Boys" },
        { name: "Under-14 Long Jump Boys", value: "Under-14 Long Jump Boys" },
        { name: "Under-14 Long Jump Girls", value: "Under-14 Long Jump Girls" },
        { name: "Under-14 Shot Put Boys", value: "Under-14 Shot Put Boys" },
        { name: "Under-14 Shot Put Girls", value: "Under-14 Shot Put Girls" },
        {
          name: "Under-14 2km Walkthon Boys",
          value: "Under-14 2km Walkthon Boys",
        },
        {
          name: "Under-14 2km Walkthon Girls",
          value: "Under-14 2km Walkthon Girls",
        },
        { name: "Under-18 100 Meter Girls", value: "Under-18 100 Meter Girls" },
        { name: "Under-18 200 Meter Girls", value: "Under-18 200 Meter Girls" },
        { name: "Under-18 400 Meter Girls", value: "Under-18 400 Meter Girls" },
        { name: "Under-18 800 Meter Girls", value: "Under-18 800 Meter Girls" },
        { name: "Under-18 100 Meter Boys", value: "Under-18 100 Meter Boys" },
        { name: "Under-18 200 Meter Boys", value: "Under-18 200 Meter Boys" },
        { name: "Under-18 400 Meter Boys", value: "Under-18 400 Meter Boys" },
        { name: "Under-18 800 Meter Boys", value: "Under-18 800 Meter Boys" },
        { name: "Under-18 Long Jump Boys", value: "Under-18 Long Jump Boys" },
        { name: "Under-18 Long Jump Girls", value: "Under-18 Long Jump Girls" },
        { name: "Under-18 Shot Put Boys", value: "Under-18 Shot Put Boys" },
        { name: "Under-18 Shot Put Girls", value: "Under-18 Shot Put Girls" },
        {
          name: "Under-18 3km Walkthon Boys",
          value: "Under-18 3km Walkthon Boys",
        },
        {
          name: "Under-18 3km Walkthon Girls",
          value: "Under-18 3km Walkthon Girls",
        },
        { name: "Under-16 100 Meter Girls", value: "Under-16 100 Meter Girls" },
        { name: "Under-16 200 Meter Girls", value: "Under-16 200 Meter Girls" },
        { name: "Under-16 400 Meter Girls", value: "Under-16 400 Meter Girls" },
        { name: "Under-16 800 Meter Girls", value: "Under-16 800 Meter Girls" },
        { name: "Under-16 100 Meter Boys", value: "Under-16 100 Meter Boys" },
        { name: "Under-16 200 Meter Boys", value: "Under-16 200 Meter Boys" },
        { name: "Under-16 400 Meter Boys", value: "Under-16 400 Meter Boys" },
        { name: "Under-16 800 Meter Boys", value: "Under-16 800 Meter Boys" },
        { name: "Under-16 Long Jump Boys", value: "Under-16 Long Jump Boys" },
        { name: "Under-16 Long Jump Girls", value: "Under-16 Long Jump Girls" },
        { name: "Under-16 Shot Put Boys", value: "Under-16 Shot Put Boys" },
        { name: "Under-16 Shot Put Girls", value: "Under-16 Shot Put Girls" },
        {
          name: "Under-16 2km Walkthon Boys",
          value: "Under-16 2km Walkthon Boys",
        },
        {
          name: "Under-16 2km Walkthon Girls",
          value: "Under-16 2km Walkthon Girls",
        },
        {
          name: "Open- 100 Meter Girls (Age 18+)",
          value: "Open- 100 Meter Girls (Age 18+)",
        },
        {
          name: "Open- 200 Meter Girls (Age 18+)",
          value: "Open- 200 Meter Girls (Age 18+)",
        },
        {
          name: "Open- 400 Meter Girls (Age 18+)",
          value: "Open- 400 Meter Girls (Age 18+)",
        },
        {
          name: "Open- 800 Meter Girls (Age 18+)",
          value: "Open- 800 Meter Girls (Age 18+)",
        },
        {
          name: "Open- 1500 Meter Girls (Age 18+)",
          value: "Open- 1500 Meter Girls (Age 18+)",
        },
        {
          name: "Open- 100 Meter Boys (Age 18+)",
          value: "Open- 100 Meter Boys (Age 18+)",
        },
        {
          name: "Open- 200 Meter Boys (Age 18+)",
          value: "Open- 200 Meter Boys (Age 18+)",
        },
        {
          name: "Open- 400 Meter Boys (Age 18+)",
          value: "Open- 400 Meter Boys (Age 18+)",
        },
        {
          name: "Open- 800 Meter Boys (Age 18+)",
          value: "Open- 800 Meter Boys (Age 18+)",
        },
        {
          name: "Open- 1500 Meter Boys (Age 18+)",
          value: "Open- 1500 Meter Boys (Age 18+)",
        },
        {
          name: "Open- Long Jump Girls (Age 18+)",
          value: "Open- Long Jump Girls (Age 18+)",
        },
        {
          name: "Open- Long Jump Boys (Age 18+)",
          value: "Open- Long Jump Boys (Age 18+)",
        },
        {
          name: "Open- Shot Put Girls (Age 18+)",
          value: "Open- Shot Put Girls (Age 18+)",
        },
        {
          name: "Open- Shot Put boys (Age 18+)",
          value: "Open- Shot Put boys (Age 18+)",
        },
        {
          name: "Open- 5km Walkthon Boys (Age 18+)",
          value: "Open- 5km Walkthon Boys (Age 18+)",
        },
        {
          name: "Open- 5km Walkthon Girls (Age 18+)",
          value: "Open- 5km Walkthon Girls (Age 18+)",
        },
        {
          name: "Masters- 100 Meter Girls (Age 35+)",
          value: "Masters- 100 Meter Girls (Age 35+)",
        },
        {
          name: "Masters- 200 Meter Girls (Age 35+)",
          value: "Masters- 200 Meter Girls (Age 35+)",
        },
        {
          name: "Masters- 400 Meter Girls (Age 35+)",
          value: "Masters- 400 Meter Girls (Age 35+)",
        },
        {
          name: "Masters- 800 Meter Girls (Age 35+)",
          value: "Masters- 800 Meter Girls (Age 35+)",
        },
        {
          name: "Masters- 1500 Meter Girls (Age 35+) ",
          value: "Masters- 1500 Meter Girls (Age 35+)",
        },
        {
          name: "Masters- 100 Meter Boys (Age 35+)",
          value: "Masters- 100 Meter Boys (Age 35+)",
        },
        {
          name: "Masters- 200 Meter Boys (Age 35+)",
          value: "Masters- 200 Meter Boys (Age 35+)",
        },
        {
          name: "Masters- 400 Meter Boys (Age 35+)",
          value: "Masters- 400 Meter Boys (Age 35+)",
        },
        {
          name: "Masters- 800 Meter Boys (Age 35+)",
          value: "Masters- 800 Meter Boys (Age 35+)",
        },
        {
          name: "Masters- 1500 Meter Boys (Age 35+)",
          value: "Masters- 1500 Meter Boys (Age 35+)",
        },
        {
          name: "Masters- Long Jump Girls (Age 35+)",
          value: "Masters- Long Jump Girls (Age 35+)",
        },
        {
          name: "Masters- Long Jump Boys (Age 35+)",
          value: "Masters- Long Jump Boys (Age 35+)",
        },
        {
          name: "Masters- Shot Put Girls (Age 35+)",
          value: "Masters- Shot Put Girls (Age 35+)",
        },
        {
          name: "Masters- Shot Put boys (Age 35+)",
          value: "Masters- Shot Put boys (Age 35+)",
        },
        {
          name: "Masters- 4km Walkthon Boys (Age 35+)",
          value: "Masters- 4km Walkthon Boys (Age 35+)",
        },
        {
          name: "Masters- 4km Walkthon Girls (Age 35+)",
          value: "Masters- 4km Walkthon Girls (Age 35+)",
        },
      ],
    },
    {
      name: "Marathon",
      value: "Marathon",
      groups: [
        { name: "U-14 Boys 2km", value: "U-14 Boys 2km" },
        { name: "U-14 Girls 2km", value: "U-14 Girls 2km" },
        { name: "U-16 Boys 3km", value: "U-16 Boys 3km" },
        { name: "U-18 Girls 4Km", value: "U-18 Girls 4Km" },
        { name: "Open-Boys 5Km", value: "Open-Boys 5Km" },
        { name: "Open-Girls 5Km", value: "Open-Girls 5Km" },
        { name: "Veterans-Mens 3Km", value: "Veterans-Mens 3Km" },
        { name: "Veterans-Womens 3km", value: "Veterans-Womens 3km" },
      ],
    },
    {
      name: "PARA ATHLETICS",
      value: "PARA ATHLETICS",
      groups: [
        { name: "Under- 18 Boys 100+200", value: "Under- 18 Boys 100+200" },
        { name: "Under- 18 Girls 100+200", value: "Under- 18 Girls 100+200" },
        { name: "Under- 18 Boys 400", value: "Under- 18 Boys 400" },
        { name: "Under- 18 Girls 400", value: "Under- 18 Girls 400" },
        { name: "Under- 18 Shot Put Boys", value: "Under- 18 Shot Put Boys" },
        { name: "Under- 18 Shot Put Girls", value: "Under- 18 Shot Put Girls" },
        { name: "Under- 18 Javlin Boys", value: "Under- 18 Javlin Boys" },
        { name: "Under- 18 Javlin Girls", value: "Under- 18 Javlin Girls" },
        {
          name: "Under- 18 Disscus Throw Boys",
          value: "Under- 18 Disscus Throw Boys",
        },
        {
          name: "Under- 18 Disscus Throw Girls",
          value: "Under- 18 Disscus Throw Girls",
        },
      ],
    },
    {
      name: "PARA SWIMMING",
      value: "PARA SWIMMING",
      groups: [
        { name: "Above- 18 Boys", value: "Above- 18 Boys" },
        { name: "Above- 18 Girls", value: "Above- 18 Girls" },
      ],
    },
    {
      name: "GYMNASTIC",
      value: "GYMNASTIC",
      groups: [
        { name: "Under - 10 Boys", value: "Under - 10 Boys" },
        { name: "Under - 10 Girls", value: "Under - 10 Girls" },
        { name: "Under - 14 Boys", value: "Under - 14 Boys" },
        { name: "Under - 14 Girls", value: "Under - 14 Girls" },
        { name: "Under - 08 Boys", value: "Under - 08 Boys" },
        { name: "Under - 08 Girls", value: "Under - 08 Girls" },
        { name: "Under - 16 Boys", value: "Under - 16 Boys" },
        { name: "Under- 16 Girls", value: "Under- 16 Girls" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "TAEKWONDO",
      value: "TAEKWONDO",
      groups: [
        { name: "Under- 11 Boys", value: "Under- 11 Boys" },
        { name: "Under- 11 Girls", value: "Under- 11 Girls" },
        { name: "Under- 14 Boys", value: "Under- 14 Boys" },
        { name: "Under- 14 Girls", value: "Under- 14 Girls" },
        { name: "Under- 17 Boys", value: "Under- 17 Boys" },
        { name: "Under- 17 Girls", value: "Under- 17 Girls" },
        { name: "Above- 18 Boys", value: "Above- 18 Boys" },
        { name: "Above- 18 Girls", value: "Above- 18 Girls" },
      ],
    },
    {
      name: "TABLE TENNIS",
      value: "TABLE TENNIS",
      groups: [
        { name: "Under- 11 Boys", value: "Under- 11 Boys" },
        { name: "Under- 11 Girls", value: "Under- 11 Girls" },
        { name: "Under- 13 Boys", value: "Under- 13 Boys" },
        { name: "Under- 13 Girls", value: "Under- 13 Girls" },
        { name: "Under- 15 Boys", value: "Under- 15 Boys" },
        { name: "Under- 15 Girls", value: "Under- 15 Girls" },
        { name: "Under- 17 Boys", value: "Under- 17 Boys" },
        { name: "Under- 17 Girls", value: "Under- 17 Girls" },
        { name: "Under- 19 Boys", value: "Under- 19 Boys" },
        { name: "Under- 19 Girls", value: "Under- 19 Girls" },
        { name: "Open Mens", value: "Open Mens" },
        { name: "Open Womens", value: "Open Womens" },
        { name: "Veteran 40+", value: "Veteran 40+" },
        { name: "Veteran 50+", value: "Veteran 50+" },
        { name: "Veteran 60+", value: "Veteran 60+" },
      ],
    },

    {
      name: "CHESS",
      value: "CHESS",
      groups: [
        { name: "1st TO 4th Boys", value: "1st TO 4th Boys" },
        { name: "1st TO 4th Girls", value: "1st TO 4th Girls" },
        { name: "5th TO 7th Boys", value: "5th TO 7th Boys" },
        { name: "5th TO 7th Girls", value: "5th TO 7th Girls" },
        { name: "8th TO 10th Boys", value: "8th TO 10th Boys" },
        { name: "8th TO 10th Girls", value: "8th TO 10th Girls" },
        { name: "MENS", value: "MENS" },
        { name: "WOMENS", value: "WOMENS" },
      ],
    },

    {
      name: "JUDO",
      value: "JUDO",
      groups: [
        { name: "Under-12 Boys", value: "Under-12 Boys" },
        { name: "Under-12 Girls", value: "Under-12 Girls" },
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
      ],
    },
    {
      name: "YOGASANA",
      value: "YOGASANA",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-18 Boys", value: "Under-18 Boys" },
        { name: "Under-18 Girls", value: "Under-18 Girls" },
        { name: "SENIOR 18-28", value: "SENIOR 18-28" },
        { name: "SENIOR 28-35", value: "SENIOR 28-35" },
        { name: "SENIOR 35-45", value: "SENIOR 35-45" },
        { name: "SENIOR 45-55", value: "SENIOR 45-55" },
      ],
    },

    {
      name: "KARATE",
      value: "KARATE",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-18 Boys", value: "Under-18 Boys" },
        { name: "Under-18 Girls", value: "Under-18 Girls" },
        { name: "ABOVE 18 Boys", value: "ABOVE 18 Boys" },
        { name: "ABOVE 18 Girls", value: "ABOVE 18 Girls" },
      ],
    },

    {
      name: "FENCING",
      value: "FENCING",
      groups: [
        { name: "Under-12 Boys", value: "Under-12 Boys" },
        { name: "Under-12 Girls", value: "Under-12 Girls" },
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-23 Boys", value: "Under-23 Boys" },
        { name: "Under-23 Girls", value: "Under-23 Girls" },
      ],
    },

    {
      name: "LAWN TENNIS",
      value: "LAWN TENNIS",
      groups: [
        { name: "Under-12 Boys", value: "Under-12 Boys" },
        { name: "Under-12 Girls", value: "Under-12 Girls" },
        { name: "Under-10 Boys", value: "Under-10 Boys" },
        { name: "Under-10 Girls", value: "Under-10 Girls" },
        { name: "Under-16 Boys", value: "Under-16 Boys" },
        { name: "Under-16 Girls", value: "Under-16 Girls" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "SWIMMING",
      value: "SWIMMING",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-18 Boys", value: "Under-18 Boys" },
        { name: "Under-18 Girls", value: "Under-18 Girls" },
        { name: "OPEN 25+ Boys", value: "OPEN 25+ Boys" },
        { name: "OPEN 25+ Girls", value: "OPEN 25+ Girls" },
        { name: "MASTERS 35+ Boys", value: "MASTERS 35+ Boys" },
        { name: "MASTERS 35+ Girls", value: "MASTERS 35+ Girls" },
      ],
    },

    {
      name: "BOXING",
      value: "BOXING",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-12 Boys", value: "Under-12 Boys" },
        { name: "Under-12 Girls", value: "Under-12 Girls" },
        { name: "Under-10 Boys", value: "Under-10 Boys" },
        { name: "Under-10 Girls", value: "Under-10 Girls" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "WEIGHTLIFTING",
      value: "WEIGHTLIFTING",
      groups: [
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "ABOVE 19 Boys", value: "ABOVE 19 Boys" },
        { name: "ABOVE 19 Girls", value: "ABOVE 19 Girls" },
      ],
    },

    {
      name: "WRESTLING",
      value: "WRESTLING",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Senior 18+ Boys", value: "Senior 18+ Boys" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "U-14 Girls", value: "U-14 Girls" },
        { name: "U-17 Girls", value: "U-17 Girls" },
        { name: "Senior 18+ Girls", value: "Senior 18+ Girls" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "SKATING",
      value: "SKATING",
      groups: [
        { name: "Under- 4 Boys", value: "Under- 4 Boys" },
        { name: "Under- 4 Girls", value: "Under- 4 Girls" },
        { name: "Under- 6 Boys", value: "Under- 6 Boys" },
        { name: "Under- 6 Girls", value: "Under- 6 Girls" },
        { name: "Under- 8 Boys", value: "Under- 8 Boys" },
        { name: "Under- 8 Girls", value: "Under- 8 Girls" },
        { name: "Under- 10 Boys", value: "Under- 10 Boys" },
        { name: "Under- 10 Girls", value: "Under- 10 Girls" },
        { name: "Under- 12 Boys", value: "Under- 12 Boys" },
        { name: "Under- 12 Girls", value: "Under- 12 Girls" },
        { name: "Under- 15 Boys", value: "Under- 15 Boys" },
        { name: "Under- 15 Girls", value: "Under- 15 Girls" },
        { name: "Under- 18 Boys", value: "Under- 18 Boys" },
        { name: "Under- 18 Girls", value: "Under- 18 Girls" },
        { name: "Under- 21 Boys", value: "Under- 21 Boys" },
        { name: "Under- 21 Girls", value: "Under- 21 Girls" },
        { name: "Under- 25 Boys", value: "Under- 25 Boys" },
        { name: "Under- 25 Girls", value: "Under- 25 Girls" },
        { name: "Under- 30 Boys", value: "Under- 30 Boys" },
        { name: "Under- 30 Girls", value: "Under- 30 Girls" },
        { name: "Under- 35 Boys", value: "Under- 35 Boys" },
        { name: "Under- 35 Girls", value: "Under- 35 Girls" },
        { name: "Under- 40 Boys", value: "Under- 40 Boys" },
        { name: "Under- 40 Girls", value: "Under- 40 Girls" },
        { name: "Under- 45 Boys", value: "Under- 45 Boys" },
        { name: "Under- 45 Girls", value: "Under- 45 Girls" },
        { name: "Under- 50 Boys", value: "Under- 50 Boys" },
        { name: "Under- 50 Girls", value: "Under- 50 Girls" },
        { name: "Under- 55 Boys", value: "Under- 55 Boys" },
        { name: "Under- 55 Girls", value: "Under- 55 Girls" },
        { name: "Under- 60 Boys", value: "Under- 60 Boys" },
        { name: "Under- 60 Girls", value: "Under- 60 Girls" },
        { name: "Under- 65 Boys", value: "Under- 65 Boys" },
        { name: "Under- 65 Girls", value: "Under- 65 Girls" },
        { name: "Under- 70 Boys", value: "Under- 70 Boys" },
        { name: "Under- 70 Girls", value: "Under- 70 Girls" },
      ],
    },
    {
      name: "JUMP ROPE",
      value: "JUMP ROPE",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "Under-23 Boys", value: "Under-23 Boys" },
        { name: "Under-23 Girls", value: "Under-23 Girls" },
      ],
    },
    {
      name: "GOLF",
      value: "GOLF",
      groups: [
        { name: "Under-14 Boy", value: "Under-14 Boy" },
        { name: "Under-14 Girl", value: "Under-14 Girl" },
        { name: "Under-17 Boy", value: "Under-17 Boy" },
        { name: "Under-17 Girl", value: "Under-17 Girl" },
        { name: "Under-19 Boy", value: "Under-19 Boy" },
        { name: "Under-19 Girl", value: "Under-19 Girl" },
        { name: "Senior19+ Men", value: "Senior19+ Men" },
        { name: "Senior19+ Women", value: "Senior19+ Women" },
        { name: "VETERANS (35+) Boys", value: "VETERANS (35+) Boys" },
        { name: "VETERANS (35+) Girls", value: "VETERANS (35+) Girls" },
      ],
    },
    {
      name: "Kick-Boxing",
      value: "Kick-Boxing",
      groups: [
        { name: "Under -12, Boys", value: "Under -12, Boys" },
        { name: "Under -12, Girls", value: "Under -12, Girls" },
        { name: "Under -18, Boys", value: "Under -18, Boys" },
        { name: "Under -18, Girls", value: "Under -18, Girls" },
        { name: "Under -25, Boys", value: "Under -25, Boys" },
        { name: "Under -25, Girls", value: "Under -25, Girls" },
      ],
    },
    {
      name: "WUSHU",
      value: "WUSHU",
      groups: [
        { name: "Under 10", value: "Under 10" },
        { name: "Under 14", value: "Under 14" },
        { name: "Under 17", value: "Under 17" },
        { name: "Under 19", value: "Under 19" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "Drop Rollball",
      value: "Drop Rollball",
      groups: [
        { name: "14 Boy Single", value: "14 Boy Single" },
        { name: "14 Girls Single", value: "14 Girls Single" },
        { name: "14 Boy Triple", value: "14 Boy Triple" },
        { name: "14 Girls Triple", value: "14 Girls Triple" },
        { name: "17 Boy Single", value: "17 Boy Single" },
        { name: "17 Girls Single", value: "17 Girls Single" },
        { name: "17 Boy Triple", value: "17 Boy Triple" },
        { name: "17 Girls Triple", value: "17 Girls Triple" },
        { name: "19 Boy Single", value: "19 Boy Single" },
        { name: "19 Girls Single", value: "19 Girls Single" },
        { name: "19 Boy Triple", value: "19 Boy Triple" },
        { name: "19 Girls Triple", value: "19 Girls Triple" },
        { name: "Open Boy Single", value: "Open Boy Single" },
        { name: "Open Girls Single", value: "Open Girls Single" },
        { name: "Open Boy Triple", value: "Open Boy Triple" },
        { name: "Open Girls Triple", value: "Open Girls Triple" },
      ],
    },

    {
      name: "Triathlon",
      value: "Triathlon",
      groups: [
        { name: "14 Boys", value: "14 Boys" },
        { name: "14 Girls", value: "14 Girls" },
        { name: "19 Boys", value: "19 Boys" },
        { name: "19 Girls", value: "19 Girls" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
        { name: "MASTERS 35+ Boys", value: "MASTERS 35+ Boys" },
        { name: "MASTERS 35+ Girls", value: "MASTERS 35+ Girls" },
      ],
    },

    {
      name: "Mallakhamb",
      value: "Mallakhamb",
      groups: [
        { name: "Under- 12 Boys", value: "Under- 12 Boys" },
        { name: "Under- 14 Boys", value: "Under- 14 Boys" },
        { name: "Under- 18 Boys", value: "Under- 18 Boys" },
        { name: "18+ Boys", value: "18+ Boys" },
      ],
    },

    {
      name: "Rope Mallakhamb",
      value: "Rope Mallakhamb",
      groups: [
        { name: "Under- 12 Girls", value: "Under- 12 Girls" },
        { name: "Under- 14 Girls", value: "Under- 14 Girls" },
        { name: "Under- 16 Girls", value: "Under- 16 Girls" },
        { name: "Above- 16 Girls", value: "Above- 16 Girls" },
      ],
    },

    {
      name: "CARROM",
      value: "CARROM",
      groups: [
        { name: "Under- 12 Boys", value: "Under- 12 Boys" },
        { name: "Under- 12 Girls", value: "Under- 12 Girls" },
        { name: "Under- 14 Boys", value: "Under- 14 Boys" },
        { name: "Under- 14 Girls", value: "Under- 14 Girls" },
        { name: "Under- 18 Boys", value: "Under- 18 Boys" },
        { name: "Under- 18 Girls", value: "Under- 18 Girls" },
        { name: "Under- 21 Boys", value: "Under- 21 Boys" },
        { name: "Under- 21 Girls", value: "Under- 21 Girls" },
        { name: "OPEN Boys", value: "OPEN Boys" },
        { name: "OPEN Girls", value: "OPEN Girls" },
      ],
    },

    {
      name: "GADHA SPORTS",
      value: "GADHA SPORTS",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },

    {
      name: "Aerobics GYMNASTIC",
      value: "Aerobics GYMNASTIC",
      groups: [
        { name: "Under-8 Boys", value: "Under-8 Boys" },
        { name: "Under-8 Girls", value: "Under-8 Girls" },
        { name: "Under-10 Boys", value: "Under-10 Boys" },
        { name: "Under-10 Girls", value: "Under-10 Girls" },
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-16 Boys", value: "Under-16 Boys" },
        { name: "Under-16 Girls", value: "Under-16 Girls" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },

    {
      name: "Archery",
      value: "Archery",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "BODY BUILDING",
      value: "BODY BUILDING",
      groups: [
        { name: "Under-23 Boys", value: "Under-23 Boys" },
        { name: "Above - 23 Boys", value: "Above - 23 Boys" },
      ],
    },

    {
      name: "RIFFLE SHOOTING",
      value: "RIFFLE SHOOTING",
      groups: [
        { name: "Under-16 Boys Air Rifle", value: "Under-16 Boys Air Rifle" },
        { name: "Under-16 Girls Air Rifle", value: "Under-16 Girls Air Rifle" },
        { name: "Under-21 BoysAir Rifle", value: "Under-21 BoysAir Rifle" },
        { name: "Under-21 Girls Air Rifle", value: "Under-21 Girls Air Rifle" },
        { name: "OPEN Boys Air Rifle", value: "OPEN Boys Air Rifle" },
        { name: "OPEN Girls Air Rifle", value: "OPEN Girls Air Rifle" },
        { name: "Under-16 Boys Air Pistol", value: "Under-16 Boys Air Pistol" },
        {
          name: "Under-16 Girls Air Pistol",
          value: "Under-16 Girls Air Pistol",
        },
        { name: "Under-21 Boys Air Pistol", value: "Under-21 Boys Air Pistol" },
        {
          name: "Under-21 Girls Air Pistol",
          value: "Under-21 Girls Air Pistol",
        },
        { name: "OPEN Boys Air Pistol", value: "OPEN Boys Air Pistol" },
        { name: "OPEN Girls Air Pistol", value: "OPEN Girls Air Pistol" },
      ],
    },
  ];

  const multiplayerGames = [
    {
      name: "KHO-KHO",
      value: "KHO-KHO",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
      ],
    },
    {
      name: "BADMINTON",
      value: "BADMINTON",
      groups: [
        {
          name: "Open Doubles Boys(Age 18+)",
          value: "Open Doubles Boys(Age 18+)",
        },
        { name: "Doubles Mens(Age35+)", value: "Doubles Mens(Age35+)" },
        {
          name: "Open Doubles Girls(Age 18+)",
          value: "Open Doubles Girls(Age 18+)",
        },
        { name: "Doubles Womens(Age35+)", value: "Doubles Womens(Age35+)" },
      ],
    },
    {
      name: "BASKETBALL",
      value: "BASKETBALL",
      groups: [
        { name: "Under - 14 Boys", value: "Under - 14 Boys" },
        { name: "Under - 12 Boys", value: "Under - 12 Boys" },
        { name: "Under - 18 Boys", value: "Under - 18 Boys" },
        { name: "OPEN (Age 18+) Boys", value: "OPEN (Age 18+) Boys" },
        { name: "MASTERS (Age 30+) Boys", value: "MASTERS (Age 30+) Boys" },
        { name: "Under - 14 Girls", value: "Under - 14 Girls" },
        { name: "Under - 12 Girls", value: "Under - 12 Girls" },
        { name: "Under- 18 Girls", value: "Under- 18 Girls" },
        { name: "OPEN (Age 18+) Girls", value: "OPEN (Age 18+) Girls" },
        { name: "MASTERS (Age 30+) Girls", value: "MASTERS (Age 30+) Girls" },
      ],
    },
    {
      name: "FOOTBALL",
      value: "FOOTBALL",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
      ],
    },
    {
      name: "TABLE TENNIS",
      value: "TABLE TENNIS",
      groups: [
        { name: "DOUBLES Male", value: "DOUBLES Male" },
        { name: "DOUBLES Female", value: "DOUBLES Female" },
        { name: "MIXED DOUBLES", value: "MIXED DOUBLES" },
      ],
    },
    {
      name: "KABADDI",
      value: "KABADDI",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "OPEN (Age 19+) Boys", value: "OPEN (Age 19+) Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "OPEN (Age 19+) Girls", value: "OPEN (Age 19+) Girls" },
      ],
    },
    {
      name: "HOCKEY",
      value: "HOCKEY",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Senior (Age 19+) Boys", value: "Senior (Age 19+) Boys" },
        { name: "Masters (Age 35+) Boys", value: "Masters (Age 35+) Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "Senior (Age 19+) Girls", value: "Senior (Age 19+) Girls" },
        { name: "Masters (Age 35+) Girls", value: "Masters (Age 35+) Girls" },
      ],
    },
    {
      name: "VOLLEYBALL",
      value: "VOLLEYBALL",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "OPEN 19+ Boys", value: "OPEN 19+ Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "OPEN 19+ Girls", value: "OPEN 19+ Girls" },
      ],
    },
    {
      name: "HAND BALL",
      value: "HAND BALL",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under- 17 Girls", value: "Under- 17 Girls" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "DODGE BALL",
      value: "DODGE BALL",
      groups: [
        { name: "Under - 17 Boys", value: "Under - 17 Boys" },
        { name: "Under - 17 Girls", value: "Under - 17 Girls" },
        { name: "Under - 19 Boys", value: "Under - 19 Boys" },
        { name: "Under - 19 Girls", value: "Under - 19 Girls" },
      ],
    },
    {
      name: "TENNIS BALL CRICKET",
      value: "TENNIS BALL CRICKET",
      groups: [{ name: "Open", value: "Open" }],
    },
    {
      name: "SOFTBALL",
      value: "SOFTBALL",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "Senior Mens", value: "Senior Mens" },
        { name: "Senior Womens", value: "Senior Womens" },
      ],
    },
    {
      name: "TUG-OF-WAR",
      value: "TUG-OF-WAR",
      groups: [
        { name: "Under-14 Boys", value: "Under-14 Boys" },
        { name: "Under-17 Boys", value: "Under-17 Boys" },
        { name: "Under-19 Boys", value: "Under-19 Boys" },
        { name: "Senior (Age 19+) Boys", value: "Senior (Age 19+) Boys" },
        { name: "Veteran  (Age 35+) Mens", value: "Veteran  (Age 35+) Mens" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Under-19 Girls", value: "Under-19 Girls" },
        { name: "Senior (Age 19+) Girls", value: "Senior (Age 19+) Girls" },
        {
          name: "Veteran  (Age 35+) Womens",
          value: "Veteran  (Age 35+) Womens",
        },
      ],
    },
    {
      name: "DROP ROLLBALL",
      value: "DROP ROLLBALL",
      groups: [
        { name: "Under-14 Boy Double", value: "Under-14 Boy Double" },
        { name: "Under-14 Girls Double", value: "Under-14 Girls Double" },
        { name: "Under-17 Boy Double", value: "Under-17 Boy Double" },
        { name: "Under-17 Girls Double", value: "Under-17 Girls Double" },
        { name: "Under-19 Boy Double", value: "Under-19 Boy Double" },
        { name: "Under-19 Girls Double", value: "Under-19 Girls Double" },
        { name: "Open Boy Double", value: "Open Boy Double" },
        { name: "Open Girls Double", value: "Open Girls Double" },
      ],
    },
    {
      name: "TENNIKOIT",
      value: "TENNIKOIT",
      groups: [
        { name: "Under - 12 Boys", value: "Under - 12 Boys" },
        { name: "Under - 12 Girls", value: "Under - 12 Girls" },
        { name: "Under - 14 Boys", value: "Under - 14 Boys" },
        { name: "Under - 14 Girls", value: "Under - 14 Girls" },
        { name: "Under - 16 Boys", value: "Under - 16 Boys" },
        { name: "Under - 16 Girls", value: "Under - 16 Girls" },
        { name: "Under - 18 Boys", value: "Under - 18 Boys" },
        { name: "Under - 18 Girls", value: "Under - 18 Girls" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "BASE BALL",
      value: "BASE BALL",
      groups: [
        { name: "Under - 14 Boys", value: "Under - 14 Boys" },
        { name: "Under - 17 Boys", value: "Under - 17 Boys" },
        { name: "Under - 19 Boys", value: "Under - 19 Boys" },
        { name: "Senior Men (Age 19+)", value: "Senior Men (Age 19+)" },
        { name: "Under - 14 Girls", value: "Under - 14 Girls" },
        { name: "Under - 17 Girls", value: "Under - 17 Girls" },
        { name: "Under - 19 Girls", value: "Under - 19 Girls" },
        { name: "Senior Women (Age 19+)", value: "Senior Women (Age 19+)" },
      ],
    },
    {
      name: "RUGBY",
      value: "RUGBY",
      groups: [
        { name: "Under -12 Boys", value: "Under -12 Boys" },
        { name: "Under -12 Girls", value: "Under -12 Girls" },
        { name: "Under - 14 Boys", value: "Under - 14 Boys" },
        { name: "Under - 17 Boys", value: "Under - 17 Boys" },
        { name: "Under - 19 Boys", value: "Under - 19 Boys" },
        { name: "Senior Men (Age 19+)", value: "Senior Men (Age 19+)" },
        { name: "Under - 14 Girls", value: "Under - 14 Girls" },
        { name: "Under - 17 Girls", value: "Under - 17 Girls" },
        { name: "Under - 19 Girls", value: "Under - 19 Girls" },
        { name: "Senior Women (Age 19+)", value: "Senior Women (Age 19+)" },
      ],
    },
    {
      name: "SHOOTING BALL",
      value: "SHOOTING BALL",
      groups: [
        { name: "Under - 17 Boys", value: "Under - 17 Boys" },
        { name: "Under - 17 Girls", value: "Under - 17 Girls" },
        { name: "Open Boys", value: "Open Boys" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "THROW BALL",
      value: "THROW BALL",
      groups: [
        { name: "Under-14 Boy", value: "Under-14 Boy" },
        { name: "Under-14 Girls", value: "Under-14 Girls" },
        { name: "Under-17 Boy", value: "Under-17 Boy" },
        { name: "Under-17 Girls", value: "Under-17 Girls" },
        { name: "Open Boy", value: "Open Boy" },
        { name: "Open Girls", value: "Open Girls" },
      ],
    },
    {
      name: "ATHLETICS",
      value: "ATHLETICS",
      groups: [
        {
          name: "Under - 14 Boys 4X100 Relay",
          value: "Under - 14 Boys 4X100 Relay",
        },
        {
          name: "Under - 14 Girls 4X100 Relay",
          value: "Under - 14 Girls 4X100 Relay",
        },
        {
          name: "Under - 16 Boys 4X100 Relay",
          value: "Under - 16 Boys 4X100 Relay",
        },
        {
          name: "Under - 16 Girls 4X100 Relay",
          value: "Under - 16 Girls 4X100 Relay",
        },
        {
          name: "Under - 16 Boys 4X400 Relay",
          value: "Under - 16 Boys 4X400 Relay",
        },
        {
          name: "Under - 16 Girls 4X400 Relay",
          value: "Under - 16 Girls 4X400 Relay",
        },
        {
          name: "Under - 18 Boys 4X100 Relay",
          value: "Under - 18 Boys 4X100 Relay",
        },
        {
          name: "Under - 18 Girls 4X100 Relay",
          value: "Under - 18 Girls 4X100 Relay",
        },
        {
          name: "Under - 18 Boys 4X400 Relay",
          value: "Under - 18 Boys 4X400 Relay",
        },
        {
          name: "Under - 18 Girls 4X400 Relay",
          value: "Under - 18 Girls 4X400 Relay",
        },
        { name: "Open Boys 4X100 Relay", value: "Open Boys 4X100 Relay" },
        { name: "Open Girls 4X100 Relay", value: "Open Girls 4X100 Relay" },
        { name: "Open Boys 4X400 Relay", value: "Open Boys 4X400 Relay" },
        { name: "Open Girls 4X400 Relay", value: "Open Girls 4X400 Relay" },
        { name: "Masters Boys 4X100 Relay", value: "Masters Boys 4X100 Relay" },
        {
          name: "Masters Girls 4X100 Relay",
          value: "Masters Girls 4X100 Relay",
        },
        { name: "Masters Boys 4X400 Relay", value: "Masters Boys 4X400 Relay" },
        {
          name: "Masters Girls 4X400 Relay",
          value: "Masters Girls 4X400 Relay",
        },
      ],
    },
  ];

  const onFinish = async (values) => {
    console.log("Success", values);

    setLoading(true);

    let URL;

    if (typeOfRegistration === "INDIVIDUAL")
      URL = NEW_INDIVIDUAL_REGISTRATION_API_CONSTANT;
    else URL = NEW_TEAM_REGISTRATION_API_CONSTANT;

    let payload = {
      vidhansabha: values.vidhansabha,
      gender: values.gender,
      age_group: ageGroup,
      applying_for: values.applying_for,
      event_name: selectedEvent,
      player_1_first_name: values.player_1_first_name,
      player_1_middlename: values.player_1_middlename,
      player_1_surname: values.player_1_surname,
      player_1_date_of_birth: values.player_1_date_of_birth,
      player_1_address: values.player_1_address,
      player_1_mobile_number: values.player_1_mobile_number,
      player_1_people_in_home: values.player_1_people_in_home,
      player_2_first_name: values.player_2_first_name,
      player_2_middlename: values.player_2_middlename,
      player_2_surname: values.player_2_surname,
      player_2_date_of_birth: values.player_2_date_of_birth,
      player_2_address: values.player_2_address,
      player_2_mobile_number: values.player_2_mobile_number,
      player_2_people_in_home: values.player_2_people_in_home,
      player_3_first_name: values.player_3_first_name,
      player_3_middlename: values.player_3_middlename,
      player_3_surname: values.player_3_surname,
      player_3_date_of_birth: values.player_3_date_of_birth,
      player_3_address: values.player_3_address,
      player_3_mobile_number: values.player_3_mobile_number,
      player_3_people_in_home: values.player_3_people_in_home,
      player_4_first_name: values.player_4_first_name,
      player_4_middlename: values.player_4_middlename,
      player_4_surname: values.player_4_surname,
      player_4_date_of_birth: values.player_4_date_of_birth,
      player_4_address: values.player_4_address,
      player_4_mobile_number: values.player_4_mobile_number,
      player_4_people_in_home: values.player_4_people_in_home,
      player_5_first_name: values.player_5_first_name,
      player_5_middlename: values.player_5_middlename,
      player_5_surname: values.player_5_surname,
      player_5_date_of_birth: values.player_5_date_of_birth,
      player_5_address: values.player_5_address,
      player_5_mobile_number: values.player_5_mobile_number,
      player_5_people_in_home: values.player_5_people_in_home,
      player_6_first_name: values.player_6_first_name,
      player_6_middlename: values.player_6_middlename,
      player_6_surname: values.player_6_surname,
      player_6_date_of_birth: values.player_6_date_of_birth,
      player_6_address: values.player_6_address,
      player_6_mobile_number: values.player_6_mobile_number,
      player_6_people_in_home: values.player_6_people_in_home,
      player_7_first_name: values.player_7_first_name,
      player_7_middlename: values.player_7_middlename,
      player_7_surname: values.player_7_surname,
      player_7_date_of_birth: values.player_7_date_of_birth,
      player_7_address: values.player_7_address,
      player_7_mobile_number: values.player_7_mobile_number,
      player_7_people_in_home: values.player_7_people_in_home,
      player_8_first_name: values.player_8_first_name,
      player_8_middlename: values.player_8_middlename,
      player_8_surname: values.player_8_surname,
      player_8_date_of_birth: values.player_8_date_of_birth,
      player_8_address: values.player_8_address,
      player_8_mobile_number: values.player_8_mobile_number,
      player_8_people_in_home: values.player_8_people_in_home,
      player_9_first_name: values.player_9_first_name,
      player_9_middlename: values.player_9_middlename,
      player_9_surname: values.player_9_surname,
      player_9_date_of_birth: values.player_9_date_of_birth,
      player_9_address: values.player_9_address,
      player_9_mobile_number: values.player_9_mobile_number,
      player_9_people_in_home: values.player_9_people_in_home,
      player_10_first_name: values.player_10_first_name,
      player_10_middlename: values.player_10_middlename,
      player_10_surname: values.player_10_surname,
      player_10_date_of_birth: values.player_10_date_of_birth,
      player_10_address: values.player_10_address,
      player_10_mobile_number: values.player_10_mobile_number,
      player_10_people_in_home: values.player_10_people_in_home,
      player_11_first_name: values.player_11_first_name,
      player_11_middlename: values.player_11_middlename,
      player_11_surname: values.player_11_surname,
      player_11_date_of_birth: values.player_11_date_of_birth,
      player_11_address: values.player_11_address,
      player_11_mobile_number: values.player_11_mobile_number,
      player_11_people_in_home: values.player_11_people_in_home,
      player_12_first_name: values.player_12_first_name,
      player_12_middlename: values.player_12_middlename,
      player_12_surname: values.player_12_surname,
      player_12_date_of_birth: values.player_12_date_of_birth,
      player_12_address: values.player_12_address,
      player_12_mobile_number: values.player_12_mobile_number,
      player_12_people_in_home: values.player_12_people_in_home,
      player_13_first_name: values.player_13_first_name,
      player_13_middlename: values.player_13_middlename,
      player_13_surname: values.player_13_surname,
      player_13_date_of_birth: values.player_13_date_of_birth,
      player_13_address: values.player_13_address,
      player_13_mobile_number: values.player_13_mobile_number,
      player_13_people_in_home: values.player_13_people_in_home,
      player_14_first_name: values.player_14_first_name,
      player_14_middlename: values.player_14_middlename,
      player_14_surname: values.player_14_surname,
      player_14_date_of_birth: values.player_14_date_of_birth,
      player_14_address: values.player_14_address,
      player_14_mobile_number: values.player_14_mobile_number,
      player_14_people_in_home: values.player_14_people_in_home,
      player_15_first_name: values.player_15_first_name,
      player_15_middlename: values.player_15_middlename,
      player_15_surname: values.player_15_surname,
      player_15_date_of_birth: values.player_15_date_of_birth,
      player_15_address: values.player_15_address,
      player_15_mobile_number: values.player_15_mobile_number,
      player_15_people_in_home: values.player_15_people_in_home,
      player_16_first_name: values.player_16_first_name,
      player_16_middlename: values.player_16_middlename,
      player_16_surname: values.player_16_surname,
      player_16_date_of_birth: values.player_16_date_of_birth,
      player_16_address: values.player_16_address,
      player_16_mobile_number: values.player_16_mobile_number,
      player_16_people_in_home: values.player_16_people_in_home,
      player_17_first_name: values.player_17_first_name,
      player_17_middlename: values.player_17_middlename,
      player_17_surname: values.player_17_surname,
      player_17_date_of_birth: values.player_17_date_of_birth,
      player_17_address: values.player_17_address,
      player_17_mobile_number: values.player_17_mobile_number,
      player_17_people_in_home: values.player_17_people_in_home,
      player_18_first_name: values.player_18_first_name,
      player_18_middlename: values.player_18_middlename,
      player_18_surname: values.player_18_surname,
      player_18_date_of_birth: values.player_18_date_of_birth,
      player_18_address: values.player_18_address,
      player_18_mobile_number: values.player_18_mobile_number,
      player_18_people_in_home: values.player_18_people_in_home,
    };

    let response = await createRegistration(URL, payload);
    console.log("registration", response);

    if (response.status) {
      message.success(response.message);

      setTimeout(() => {
        window.location.href = "/success";
      }, 1500);
    } else {
      message.error(message.error);
    }

    setLoading(false);
  };

  return (
    <Spin spinning={loading}>
      <h1 style={{ width: "100%", textAlign: "center" }}>Registration Form</h1>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "12px 20px",
        }}
      >
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 10 }}
          onFinish={onFinish}
          style={{ width: "100%" }}
        >
          <Form.Item
            label="Type of Registration"
            name="type_of_registration"
            rules={[{ required: true, message: "This field is required!" }]}
          >
            <Radio.Group
              onChange={(e) => setTypeOfRegistration(e.target.value)}
            >
              <Radio.Button value="INDIVIDUAL">INDIVIDUAL</Radio.Button>
              <Radio.Button value="TEAM">TEAM</Radio.Button>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="Vidhansabha"
            name="vidhansabha"
            rules={[{ required: true, message: "This field is required!" }]}
          >
            <Select
              style={{ maxWidth: "400px" }}
              placeholder="Select event name"
            >
              <Select.Option value="गंगापूर">गंगापूर</Select.Option>
              <Select.Option value="वैजापूर">वैजापूर</Select.Option>
              <Select.Option value="कन्नड">कन्नड</Select.Option>
              <Select.Option value="छ. संभाजीनगर (मध्य)">
                छ. संभाजीनगर (मध्य)
              </Select.Option>
              <Select.Option value="छ. संभाजीनगर (पश्चिम)">
                छ. संभाजीनगर (पश्चिम)
              </Select.Option>
              <Select.Option value="छ. संभाजीनगर">छ. संभाजीनगर</Select.Option>
              {/* <Select.Option value="CARROM">CARROM</Select.Option> */}
            </Select>
          </Form.Item>

          {typeOfRegistration === "INDIVIDUAL" && (
            <Form.Item
              label="Gender"
              name="gender"
              rules={[{ required: true, message: "This field is required!" }]}
            >
              <Radio.Group>
                <Radio.Button value="MALE">MALE</Radio.Button>
                <Radio.Button value="FEMALE">FEMALE</Radio.Button>
              </Radio.Group>
            </Form.Item>
          )}

          {typeOfRegistration === "TEAM" && (
            <Form.Item
              label="Team Type"
              name="team_type"
              rules={[{ required: true, message: "This field is required!" }]}
            >
              <Radio.Group>
                <Radio.Button value="MALE TEAM">MALE TEAM</Radio.Button>
                <Radio.Button value="FEMALE TEAM">FEMALE TEAM</Radio.Button>
              </Radio.Group>
            </Form.Item>
          )}

          <Form.Item
            label="Applying For"
            name="applying_for"
            rules={[{ required: true, message: "This field is required!" }]}
          >
            <Select
              style={{ maxWidth: "400px" }}
              placeholder="Select event type"
              onSelect={(value) => setEventType(value)}
            >
              <Select.Option value="GAMES">GAMES</Select.Option>
              <Select.Option value="CULTURAL EVENT">
                CULTURAL EVENT
              </Select.Option>
            </Select>
          </Form.Item>

          {typeOfRegistration === "INDIVIDUAL" && eventType === "GAMES" && (
            <>
              <Form.Item
                label="Event Name"
                name="event_name"
                rules={[{ required: true, message: "This field is required!" }]}
              >
                <Select
                  style={{ maxWidth: "400px" }}
                  placeholder="Select event name"
                  onChange={handleEventChange}
                >
                  {singlePlayerGames?.map((game) => (
                    <Select.Option key={game.value} value={game.value}>
                      {game.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              {selectedEvent && (
                <Form.Item
                  label="Age Group"
                  name="age_group"
                  rules={[
                    { required: true, message: "This field is required!" },
                  ]}
                >
                  <Select
                    style={{ maxWidth: "400px" }}
                    placeholder="Select age group"
                    onChange={handleSubcategoryChange}
                  >
                    {subcategories?.map((sub) => (
                      <Select.Option key={sub.value} value={sub.value}>
                        {sub.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </>
          )}

          {typeOfRegistration === "TEAM" &&
            eventType ===
              "GAMES"&& (
                <>
                  <Form.Item
                    label="Event Name"
                    name="event_name"
                    rules={[
                      { required: true, message: "This field is required!" },
                    ]}
                  >
                    <Select
                      style={{ maxWidth: "400px" }}
                      placeholder="Select event name"
                      onChange={handleEventChange}
                    >
                      {multiplayerGames?.map((game) => (
                        <Select.Option key={game.value} value={game.value}>
                          {game.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  {selectedEvent && (
                    <Form.Item
                      label="Age Group"
                      name="age_group"
                      rules={[
                        { required: true, message: "This field is required!" },
                      ]}
                    >
                      <Select
                        style={{ maxWidth: "400px" }}
                        placeholder="Select age group"
                        onChange={handleSubcategoryChange}
                      >
                        {subcategories?.map((sub) => (
                          <Select.Option key={sub.value} value={sub.value}>
                            {sub.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                </>
              )}

          {eventType === "CULTURAL EVENT" && (
            <>
              <Form.Item
                label="Event Name"
                name="event_name"
                rules={[{ required: true, message: "This field is required!" }]}
              >
                <Select
                  style={{ maxWidth: "400px" }}
                  placeholder="Select event name"
                  onChange={handleEventChange}
                >
                  <Select.Option value="DANCE">DANCE</Select.Option>
                  <Select.Option value="MUSICAL CHAIR">
                    MUSICAL CHAIR
                  </Select.Option>
                  <Select.Option value="ONE ACT PLAY">
                    ONE ACT PLAY
                  </Select.Option>
                  <Select.Option value="ORATORY COMPETITION">
                    ORATORY COMPETITION
                  </Select.Option>
                  <Select.Option value="PAINTING">PAINTING</Select.Option>
                  <Select.Option value="RANGOLI">RANGOLI</Select.Option>
                  <Select.Option value="SINGING">SINGING</Select.Option>
                </Select>
              </Form.Item>
            </>
          )}

          <Form.Item
            size="large"
            label="Player 1 First Name"
            name="player_1_first_name"
            rules={[{ required: true, message: "This field is required!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Player 1 Middle Name"
            name="player_1_middlename"
            rules={[{ required: true, message: "This field is required!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Player 1 Last Name"
            name="player_1_surname"
            rules={[{ required: true, message: "This field is required!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Player 1 Whatsapp Mobile Number"
            name="player_1_mobile_number"
            rules={[
              {
                required: true,
                pattern: /^[789]\d{9}$/,
                message: "Enter valid mobile number",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Player 1 Date of Birth"
            name="player_1_date_of_birth"
            rules={[{ required: true, message: "This field is required!" }]}
          >
            <DatePicker style={{ width: "250px" }} />
          </Form.Item>
          <Form.Item
            label="Player 1 Address"
            name="player_1_address"
            rules={[{ required: true, message: "This field is required!" }]}
          >
            <TextArea />
          </Form.Item>
          <Form.Item
            label="Number of People Above age 18 in the home"
            name="player_1_people_in_home"
            rules={[{ required: true, message: "This field is required!" }]}
          >
            <InputNumber min={1} max={20} style={{ width: "125px" }} />
          </Form.Item>

          {typeOfRegistration === "TEAM" && (
            <>
              <Form.Item label="Player 2 First Name" name="player_2_first_name">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 2 Middle Name"
                name="player_2_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 2 Last Name" name="player_2_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 2 Mobile Number"
                name="player_2_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 2 Date of Birth"
                name="player_2_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 2 Address" name="player_2_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_2_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item label="Player 3 First Name" name="player_3_first_name">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 3 Middle Name"
                name="player_3_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 3 Last Name" name="player_3_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 3 Mobile Number"
                name="player_3_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 3 Date of Birth"
                name="player_3_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 3 Address" name="player_3_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_3_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item label="Player 4 First Name" name="player_4_first_name">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 4 Middle Name"
                name="player_4_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 4 Last Name" name="player_4_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 4 Mobile Number"
                name="player_4_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 4 Date of Birth"
                name="player_4_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 4 Address" name="player_4_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_4_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item label="Player 5 First Name" name="player_5_first_name">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 5 Middle Name"
                name="player_5_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 5 Last Name" name="player_5_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 5 Mobile Number"
                name="player_5_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 5 Date of Birth"
                name="player_5_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 5 Address" name="player_5_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_5_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item label="Player 6 First Name" name="player_6_first_name">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 6 Middle Name"
                name="player_6_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 6 Last Name" name="player_6_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 6 Mobile Number"
                name="player_6_mobile_number_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 6 Date of Birth"
                name="player_6_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 6 Address" name="player_6_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_6_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item label="Player 7 First Name" name="player_7_first_name">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 7 Middle Name"
                name="player_7_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 7 Last Name" name="player_7_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 7 Mobile Number"
                name="player_7_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 7 Date of Birth"
                name="player_7_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 7 Address" name="player_3_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_3_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item label="Player 8 First Name" name="player_8_first_name">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 8 Middle Name"
                name="player_8_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 8 Last Name" name="player_8_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 8 Mobile Number"
                name="player_8_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 8 Date of Birth"
                name="player_8_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 8 Address" name="player_8_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_8_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item label="Player 9 First Name" name="player_9_first_name">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 9 Middle Name"
                name="player_9_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 9 Last Name" name="player_9_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 9 Mobile Number"
                name="player_9_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 9 Date of Birth"
                name="player_9_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 9 Address" name="player_9_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_9_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item
                label="Player 10 First Name"
                name="player_10_first_name"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 10 Middle Name"
                name="player_10_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 10 Last Name" name="player_10_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 10 Mobile Number"
                name="player_10_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 10 Date of Birth"
                name="player_10_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 10 Address" name="player_10_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_10_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item
                label="Player 11 First Name"
                name="player_11_first_name"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 11 Middle Name"
                name="player_11_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 11 Last Name" name="player_11_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 11 Mobile Number"
                name="player_11_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 11 Date of Birth"
                name="player_11_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 11 Address" name="player_11_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_11_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item
                label="Player 12 First Name"
                name="player_12_first_name"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 12 Middle Name"
                name="player_12_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 12 Last Name" name="player_12_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 12 Mobile Number"
                name="player_12_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 12 Date of Birth"
                name="player_12_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 12 Address" name="player_12_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_12_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item
                label="Player 13 First Name"
                name="player_13_first_name"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 13 Middle Name"
                name="player_13_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 13 Last Name" name="player_13_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 13 Mobile Number"
                name="player_13_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 13 Date of Birth"
                name="player_13_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 13 Address" name="player_13_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_13_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item
                label="Player 14 First Name"
                name="player_14_first_name"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 14 Middle Name"
                name="player_14_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 14 Last Name" name="player_14_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 14 Mobile Number"
                name="player_14_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 14 Date of Birth"
                name="player_14_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 14 Address" name="player_14_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_14_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item
                label="Player 15 First Name"
                name="player_15_first_name"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 15 Middle Name"
                name="player_15_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 15 Last Name" name="player_15_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 15 Mobile Number"
                name="player_15_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 15 Date of Birth"
                name="player_15_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 15 Address" name="player_15_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_15_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item
                label="Player 16 First Name"
                name="player_16_first_name"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 16 Middle Name"
                name="player_16_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 16 Last Name" name="player_16_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 16 Mobile Number"
                name="player_16_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 16 Date of Birth"
                name="player_16_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 16 Address" name="player_16_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_16_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item
                label="Player 17 First Name"
                name="player_17_first_name"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 17 Middle Name"
                name="player_17_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 17 Last Name" name="player_17_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 17 Mobile Number"
                name="player_17_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 17 Date of Birth"
                name="player_17_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 17 Address" name="player_17_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_17_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
              <Form.Item
                label="Player 18 First Name"
                name="player_18_first_name"
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 18 Middle Name"
                name="player_18_middlename"
              >
                <Input />
              </Form.Item>
              <Form.Item label="Player 18 Last Name" name="player_18_surname">
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 18 Mobile Number"
                name="player_18_mobile_number"
                rules={[
                  {
                    pattern: /^[789]\d{9}$/,
                    message: "Enter valid mobile number",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Player 18 Date of Birth"
                name="player_18_date_of_birth"
              >
                <DatePicker style={{ width: "250px" }} />
              </Form.Item>
              <Form.Item label="Player 18 Address" name="player_18_address">
                <TextArea />
              </Form.Item>
              <Form.Item
                label="Number of People Above age 18 in the home"
                name="player_18_people_in_home"
              >
                <InputNumber min={1} max={20} style={{ width: "125px" }} />
              </Form.Item>
            </>
          )}

          <Form.Item wrapperCol={{ span: 24 }}>
            <Button block type="primary" htmlType="submit">
              SUBMIT
            </Button>
          </Form.Item>
        </Form>
      </div>
      <Divider />
      <div style={{ margin: "15px" }}>
        <b>
          Instruction :- <br />
          1. All matches will be conducted as per National Sports Federation
          rules. <br />
          2. Umpires & Management committee decision will be final. <br />
          3. It is must for all Player’s to produce original any one of below
          mention birth proof during matches (Aadhar Card / TC / Driving License
          / Pan Card). <br />
          4. Last Date of Entry is 11 January 2024.
        </b>
      </div>
    </Spin>
  );
};

export default RegistrationFormComponent;
